export default "__VITE_ASSET__613ad3a3__"